import * as React from 'react';
import type { DataGridStrings } from '../../data-grid.type';
import { Overlay } from './index';

interface NoColumnsOverlayProps {
	strings?: DataGridStrings;
}

const DEFAULT_NO_COLUMNS_MESSAGE = 'No columns are currently visible. Use the column visibility menu to show columns.';

export const NoColumnsOverlay: React.FC<NoColumnsOverlayProps> = ({ strings }) => {
	const message = strings?.noColumnsMessage || DEFAULT_NO_COLUMNS_MESSAGE;

	return (
		<Overlay data-aid="data-grid-no-columns-overlay">
			<span className="text-sm text-tertiary">{message}</span>
		</Overlay>
	);
};
